<template>
  <div>
    <a-upload :action="action"
              name="media"
              :headers="{token: token}"
              listType="picture-card"
              :fileList="fileList"
              :data="data"
              @preview="handlePreview"
              @change="handleChange">
      <div v-if="fileList.length < max">
        <dol-icon type="PlusOutlined"/>
        <div class="ant-upload-text">上传图片</div>
      </div>
    </a-upload>
    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
      <img alt="example" style="width: 100%" :src="previewImage"/>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'dol-upload-img-list',
  props: {
    value: {type: Array},
    type: {type: String, default: ''},            //文件类型，可为空
    url: {type: String, default: '/system/tool/file/save'},            //文件类型，可为空
    max: {type: Number, default: 3},             //最大上传数
    data: {type: Object, default: () => {return {}}},            //数据绑定
  },
  data(){
    return {
      previewVisible: false,
      previewImage: '',
      fileList: this.value,
      fileListInside: [],
    }
  },
  computed:{
    ...mapGetters(['token']),
    action(){
      let action = this.$Dolphin.path.apiPath + this.url;
      if(this.type){
        action += `?type=${this.type}`;
      }
      return action;
    }
  },
    watch: {
      value(val) {
        this.updateData(val);
      }
    },
  methods: {
    handleCancel() {
      this.previewVisible = false
    },
    handlePreview(file) {
      this.previewImage = file.url || file.thumbUrl || file.filePath;
      this.previewVisible = true
    },
    // 图片list有更新时触发（新增、删除、更改）
    handleChange({fileList}) {
      let flag = true, value = [];
      fileList.forEach((item, i) => {
        value.push(item.dataSource || (item.response && item.response.data));
        if (item.response) {
          fileList[i].url = this.$Dolphin.path.publicPath + item.response.data.filePath;
          fileList[i].uid = item.response.data._id;
        }
        if (flag) {
          flag = item.status === 'done';
        }
      });
      this.fileList = fileList;
      // 确保上传完成后再写出文件list
      if (flag) {
        this.$emit('input', value)
      }
    },
    //数据初始化
    updateData(val) {
      this.fileList = [];
      val.forEach((img, i) => {
        this.fileList.push({
          name: img.name,
          uid: img.uid || img._id,
          fileId: img.fileId || img._id,
          status: img.status || 'done',
          url: img.url || this.$Dolphin.path.publicPath + img.filePath,
          dataSource: val[i],
        });
      });
    },
  },
  created(){
    this.updateData(this.value);
  }
}
</script>
<style>
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
</style>

